import BaseModelRequest from "./base/BaseModelRequest";

export default class BalanceRequest extends BaseModelRequest {
  getBalanceTransactionMain(currency) {
    return this.get(`/balance-transaction-main/${currency}`);
  }
  getCoinSupportedNetworks(coin) {
    return this.get(`/coin-supported-networks?coin=${coin}`);
  }
}
